import { z } from "zod";
import { merchantHomeWorkbenchCardTypeSchema } from "./merchantHomeSchemas";
import { workbenchSavedSchema } from "./workbench/layoutSchemas";

export const railComponentSchema = z.object({ instance_id: z.uuid(), card_type: merchantHomeWorkbenchCardTypeSchema }).strict();
export const railComponentsSchema = z.object({
  schema_version: z.literal(1), revision: z.string().regex(/^[1-9]\d*$/u),
  items: z.array(railComponentSchema).superRefine((items, ctx) => {
    if (new Set(items.map(item => item.card_type)).size !== items.length || new Set(items.map(item => item.instance_id)).size !== items.length) ctx.addIssue({ code: "custom", message: "组件类型与实例不能重复" });
  }),
}).strict();
export const railComponentAddSchema = z.object({ card_type: merchantHomeWorkbenchCardTypeSchema, index: z.number().int().nonnegative().optional() }).strict();
export const componentTransferSchema = z.object({
  card_type: merchantHomeWorkbenchCardTypeSchema, instance_id: z.uuid(),
  target_index: z.number().int().nonnegative().optional(),
  source: z.enum(["rail", "workbench"]), target: z.enum(["rail", "workbench"]),
  expected_rail_revision: z.string().regex(/^[1-9]\d*$/u),
  expected_workbench_revision: z.string().regex(/^(0|[1-9]\d*)$/u),
}).strict().refine(value => value.source !== value.target, "请选择另一个组件区域");
export const componentTransferResponseSchema = z.object({ rail: railComponentsSchema, workbench: workbenchSavedSchema }).strict().superRefine((value, ctx) => {
  const types = new Set(value.rail.items.map(item => item.card_type));
  if (value.workbench.layout.items.some(item => types.has(item.card_type))) ctx.addIssue({ code: "custom", message: "同一组件不能同时出现在两个区域" });
});
export type RailComponents = z.infer<typeof railComponentsSchema>;
export type ComponentTransfer = z.infer<typeof componentTransferSchema>;
